import React from 'react';
import PropTypes from 'prop-types';
import QuoteCarouselCard from './QuoteCarouselCard';
import Carousel, { slickBreakpoints } from './Carousel';

const QuoteCarousel = ({ carouselTitle, quotes }) => {
  const quoteSliderSettings = {
    centerMode: true,
    centerPadding: '24px',
    responsive: [
      {
        breakpoint: slickBreakpoints.mobile,
        settings: {
          arrows: false,
          centerPadding: '0px',
        },
      },
    ],
    className: 'quote-carousel',
  };

  return (
    <div className="content-wrapper">
      <div className="scalable-content-section quote-carousel-section">
        <p className="quote-carousel__title">{carouselTitle}</p>
        <Carousel options={quoteSliderSettings}>
          {quotes.map((quote, i) => {
            return <QuoteCarouselCard key={i} {...quote} />;
          })}
        </Carousel>
      </div>
    </div>
  );
};

QuoteCarousel.propTypes = {
  quotes: PropTypes.arrayOf(PropTypes.object),
  carouselTitle: PropTypes.string,
};

export default QuoteCarousel;
